// Theme-owned gallery isolation. Media mappings use variant IDs, independent of locale.
(() => {
  if (window.trobartVariantGallery) return;
  window.trobartVariantGallery = true;
  const metadataSelector = 'script[data-trobart-variant-galleries]';
  const number = value => String(value || '').split('/').pop().split('-').pop();
  const dimensions = value => {
    const match = String(value || '').match(/(\d+)\s*[×x]\s*(\d+)/i);
    return match ? `${match[1]}x${match[2]}` : '';
  };

  function showVariant(product, variant) {
    const metadata = product.querySelector(metadataSelector);
    const gallery = product.querySelector('media-gallery');
    if (!metadata || !gallery) return;
    const picker = product.querySelector('variant-selects');
    if (!variant) {
      try { variant = JSON.parse(picker?.querySelector('[data-selected-variant]')?.textContent || 'null'); }
      catch { /* Fall back to the native form and server-selected variant. */ }
    }
    const identifier = variant?.id || product.querySelector('form input[name="id"]')?.value || metadata.dataset.variantId;
    const slides = [...gallery.querySelectorAll('.product__media-list > li[data-media-id]')];
    const thumbnails = [...gallery.querySelectorAll('.thumbnail-list > li[data-target]')];
    const modalId = product.querySelector('modal-opener[data-modal]')?.dataset.modal;
    const modal = modalId ? document.querySelector(modalId) : product.querySelector('product-modal');
    const zoom = [...(modal?.querySelectorAll('.product-media-modal__content > [data-media-id]') || [])];
    let definitions;
    try { definitions = JSON.parse(metadata.textContent); } catch { return; }
    let ids = definitions?.[String(identifier)];

    if (!Array.isArray(ids) && metadata.dataset.legacyCims === 'true') {
      // Older 100 Cims products have one style and size labels on every image.
      // The refuge is shared by sizes; captions are translated on the storefront.
      const size = dimensions(variant?.sku?.split('-').pop()) || dimensions(variant?.title) ||
        [...(picker?.querySelectorAll('input:checked, select option:checked') || [])]
          .map(option => dimensions(option.value)).find(Boolean);
      if (!size) return;
      const alt = slide => slide.querySelector('img[alt]')?.alt || '';
      const shared = text => /totes les mides|todos los tama[ñn]os|all sizes/i.test(text);
      let master = size;
      if (slides.length === 18 && !slides.some(slide => dimensions(alt(slide)) === size)) {
        master = ['21x30', '30x40'].includes(size) ? '30x40' : '70x100';
      }
      ids = slides.filter(slide => dimensions(alt(slide)) === master || shared(alt(slide)))
        .map(slide => number(slide.dataset.mediaId));
    }
    if (!Array.isArray(ids) || !ids.length) return;
    const allowed = new Set(ids.map(number));
    const available = slides.filter(slide => allowed.has(number(slide.dataset.mediaId)));
    if (!available.length) return;
    const apply = (element, id) => {
      element.hidden = !allowed.has(number(id));
      element.style.display = element.hidden ? 'none' : '';
    };
    slides.forEach(slide => apply(slide, slide.dataset.mediaId));
    thumbnails.forEach(item => apply(item, item.dataset.target));
    zoom.forEach(item => apply(item, item.dataset.mediaId));
    const lead = available.find(slide => number(slide.dataset.mediaId) === number(ids[0])) || available[0];
    gallery.setActiveMedia?.(lead.dataset.mediaId, false);
    gallery.elements?.viewer?.resetPages?.();
    gallery.elements?.thumbnails?.resetPages?.();
  }

  function start() {
    const products = () => [...document.querySelectorAll('product-info')]
      .filter(product => product.querySelector(metadataSelector));
    products().forEach(product => showVariant(product));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        // Native product-info replaces the picker and zoom content before publishing.
        products().filter(product => product.dataset.section === data?.sectionId)
          .forEach(product => showVariant(product, data.variant));
      });
    }
    window.addEventListener('popstate', () => products().forEach(product => showVariant(product)));
    document.addEventListener('shopify:section:load', () => products().forEach(product => showVariant(product)));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
